import { BasicEntity } from "projects/erp-app/src/app/core/models/basic-entity";

export class ThirdCommunicationLabel extends BasicEntity {}